import type { FunctionComponent, ReactElement } from 'react';

import { CRASH_GAMES, GAME_SHOW_TYPE } from '../../config/CoreConstants';
import { L10nText } from '../../services/uiTranslations/reactBindings/L10nText';

interface DealerNameProps {
  gameType: string;
  name?: string;
}

export const DealerName: FunctionComponent<DealerNameProps> = ({ name, gameType }): ReactElement | null => {
  const isCrashGame = CRASH_GAMES.includes(gameType);
  const isGameShow = GAME_SHOW_TYPE.includes(gameType);

  return isCrashGame ? null : (
    <div>
      {name && isGameShow ? (
        <>
          <L10nText tk="PRESENTER" />: {name}
        </>
      ) : (
        <>
          <L10nText tk="DEALER" />: {name || <L10nText tk="NO_DEALER" />}
        </>
      )}
    </div>
  );
};
